<template>
  <div class="content">
    <div class="condition">
      <div class="check_wrap">
        <el-radio-group v-model="radio1" @change="radioChange" size="small">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">公司</el-radio-button>
          <el-radio-button label="2">个人</el-radio-button>
        </el-radio-group>
      </div>
      <div class="search_wrap">
        <el-form :inline="true" :model="formdata" class="form-inline">
          <el-form-item>
            <el-date-picker
                    v-model="formdata.user"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="small"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formdata.user" placeholder="请输入关键词查找" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small"></el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" type="selection"></el-table-column>
        <el-table-column prop="date" label="评论日期" width="180"></el-table-column>
        <el-table-column prop="name" label="评论" width="180"></el-table-column>
        <el-table-column prop="address" label="来源"></el-table-column>
        <el-table-column prop="address" label="动态内容"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- @click="handleClick(scope.row)" -->
            <el-button type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
                background
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                layout="total, prev, pager, next"
                :total="page.total"
                @current-change="pageIndexChange"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {pagination} from "@/util/util.js";

  export default {
    name: "commentsPannel",
    data() {
      return {
        formdata: {
          user: ""
        },
        radio1: 0,
        tableData: [],
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
      };
    },
    methods: {
      radioChange(option) {
        // 选择radio
        this.radio1 = option
      },
    }
  };
</script>
